import React from 'react';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = (props) => {
    return (
        <DatePicker
            dateFormat="dd/MM/yyyy"
            className="form-control"
            {...props}
        />
    );
};

export default CustomDatePicker;